import { getStyle } from "./getStyle";
import { isHiddenWithinTree } from "./utils/isHiddenWithinTree";

const defaultDisplayMap: Record<string, string> = {}

const getDefaultDisplay = (elem: HTMLElement) => {

  const doc = elem.ownerDocument;
  const nodeName = elem.nodeName;
  let display = defaultDisplayMap[nodeName];

  if (display) {
    return display;
  }

  const temp = doc.body.appendChild(doc.createElement(nodeName));

  display = getStyle(temp, "display");

  temp.parentNode!.removeChild(temp);

  if (display === "none") {
    display = "block";
  }
  defaultDisplayMap[nodeName] = display;
  return display;
}

type valueType = string | null

export const showHide = (element: string | HTMLElement | NodeListOf<HTMLElement> | HTMLElement[], show: boolean) => {
  const elements =
    typeof element === "string" ? document.querySelectorAll<HTMLElement>(element) :
      element instanceof HTMLElement ? [element] : element;

  const values: valueType[] = []
  for (let index = 0; index < elements.length; index++) {

    const elem = elements[index];
    if (!elem.style) {
      return
    }

    let display = elem.style.display;
    if (show) {
      if (display === "none") {
        values[index] = null;
        if (!values[index]) {
          elem.style.display = "";
        }
      } 
      if (elem.style.display === "" && isHiddenWithinTree(elem)) {
        values[index] = getDefaultDisplay(elem);
      }
    } else {
      if (display !== "none") {
        values[index] = "none";
      }
    }
  }
  for (let index = 0; index < length; index++) {
    if (values[index] != null) {
      elements[index].style.display = values[index]!;
    }
  }

  return elements;
}